<div class="body">
  <div class="container mt-4">
    @if (editar) {
      <div class="title-box">
        <h3 class="txtbienvenida">Editar línea<span class="txtbienvenida-2"> Aliado Financiero</span></h3>
      </div>
    }
    @if (!editar) {
      <div class="title-box">
        <h3 class="txtbienvenida">Crear nueva línea<span class="txtbienvenida-2"> Aliado Financiero</span></h3>
      </div>
    }
    <div class="container mt-4">
      <form [formGroup]="datosLineaIntermediarioForm" (ngSubmit)="idLineaCredito ? editarDatosLineaIntermediario() : guardarDatosLineaIntermediario()">
        <div class="row myForm">
          <div class="col-12 col-sm-6 col-md-6 col-lg-12 col-xs-6">
            <div class="mb-3 required form-label">
              <label for="nombreLinea" class="form-label">Nombre de línea</label>
              <select name="selValue" class="form-control" [ngClass]="{'is-invalid':isValidFieldDatosLineaIntermediarioForm('idNombreLineasCredito')}"
                formControlName="idNombreLineasCredito" title="Seleccione..."  required>
                <option value="">Selccione opción</option>
                @for (list of listLineasAliado; track list) {
                  <option [value]="list.idNombreLineasCredito">
                    {{ list.nombreLinea }}
                  </option>
                }
              </select>
              <div class="invalid-feedback">Campo obligatorio</div>
            </div>
          </div>
        </div>
        <div class="row myForm">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
                        <div class="mb-3 required form-label" [ngClass]="{
              err: isValidFieldDatosLineaIntermediarioForm('nombreLinea')
            }">
              <label for="descripcion" class="form-label">Descripción de la línea</label>
                            <input type="text" maxlength="180" class="form-control" [ngClass]="{
                'is-invalid':
                  isValidFieldDatosLineaIntermediarioForm('nombreLinea')
              }" formControlName="nombreLinea" required />
                <div class="invalid-feedback">
                  Campo obligatorio, sin espacios al final
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
                        <div class="mb-3 required form-label" [ngClass]="{
              'is-invalid':
                isValidFieldDatosLineaIntermediarioForm('estadoLinea')
            }">
                <label for="estadoLinea" class="form-label">Estado de la línea</label>
                <select class="form-control" formControlName="estadoLinea" title="Seleccione..." required>
                  <option value="habilitada">Habilitada</option>
                  <option value="deshabilitada">Deshabilitada</option>
                </select>

                <div class="invalid-feedback">Campo obligatorio</div>
              </div>
            </div>
          </div>
          <div class="row myForm">
            <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
              <div class="mb-3 required form-label">
                <label for="plazoInicial" class="form-label">Plazo inicial permitido línea (meses)</label>
                            <select class="form-control selectpicker" data-size="6" data-live-search="true" [ngClass]="{
                'is-invalid':
                  isValidFieldDatosLineaIntermediarioForm('plazoInicial')
              }" formControlName="plazoInicial" (change)="validarPlazos()" title="Seleccione..." required>
                  <option value="0">0</option>
                  @for (i of mesesPlazo; track i) {
                    <option [value]="i">
                      {{ i }}
                    </option>
                  }
                </select>
                <div class="invalid-feedback">Campo obligatorio</div>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
              <div class="mb-3 required form-label">
                <label for="plazoFinal" class="form-label">Plazo final permitido línea (meses)</label>
                            <select class="form-control selectpicker" data-size="6" data-live-search="true" [ngClass]="{
                'is-invalid':
                  isValidFieldDatosLineaIntermediarioForm('plazoFinal')
              }" formControlName="plazoFinal" (change)="validarPlazos()" title="Seleccione..." required>
                  <option value="0">0</option>
                  @for (i of mesesPlazo; track i) {
                    <option [value]="i">
                      {{ i }}
                    </option>
                  }
                </select>
                <div class="invalid-feedback">Campo obligatorio</div>
              </div>
            </div>
          </div>
          <div class="row myForm">
            <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
              <div class="mb-3 form-label">
                <label for="periodoGracia" class="form-label">Período de gracia inicial (meses)</label>
                <select class="form-control selectpicker" data-size="6" [ngClass]="{'is-invalid':isValidFieldDatosLineaIntermediarioForm('periodoInicial')}" formControlName="periodoInicial" (change)="validarPeriodos()" title="Seleccione...">
                  <option value="0">0</option>
                  @for (i of mesesPeriodo; track i) {
                    <option [value]="i">
                      {{ i }}
                    </option>
                  }
                </select>
                <div class="invalid-feedback">Campo obligatorio</div>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
              <div class="mb-3 form-label">
                <label for="periodoFinal" class="form-label">Período de gracia final (meses)</label>
                <select class="form-control selectpicker" data-size="6" [ngClass]="{'is-invalid':isValidFieldDatosLineaIntermediarioForm('periodoFinal')}" formControlName="periodoFinal" (change)="validarPeriodos()" title="Seleccione...">
                  <option value="0">0</option>
                  @for (i of mesesPeriodo; track i) {
                    <option [value]="i">
                      {{ i }}
                    </option>
                  }
                </select>
                <div class="invalid-feedback">Campo obligatorio</div>
              </div>
            </div>
          </div>
          <div class="row myForm">
            <div class="col-12 col-sm-6 col-md-6 col-lg-12 col-xs-6">
              <div class="mb-3 required form-label">
                <label for="periocidad" class="form-label">Periodicidades de pago</label>
                <select name="selValue" class="form-control selectpicker" [ngClass]="{'is-invalid':isValidFieldDatosLineaIntermediarioForm('periodicidadPagos')}" formControlName="periodicidadPagos" title="Seleccione..." multiple required>
                  @for (tp of tiposPeriodicidad; track tp) {
                    <option [value]="tp.idTipoPeriodicidad">
                      {{ tp.nombre }}
                    </option>
                  }
                </select>
                <div class="invalid-feedback">Campo obligatorio</div>
              </div>
            </div>
          </div>

          <div class="row myForm">
            <div class="col-12 col-sm-6 col-md-6 col-lg-12 col-xs-6">
              <div class="hr bg-green">Tasas permitidas para la línea</div>
            </div>
          </div>
          <div class="row myForm">
            <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
              <div class="mb-3 form-label" [ngClass]="{err: isValidFieldDatosLineaIntermediarioForm('valorTasa')}">
                <label for="tasa" class="form-label">Tasa E.A.</label>
                <input type="text" #valorTasa class="form-control" maxlength="5" (keyup)="validarTasa()"
                  (keypress)="validateNumber($event)" [ngClass]="{'is-invalid':isValidFieldDatosLineaIntermediarioForm('valorTasa')}" formControlName="valorTasa"  />
                  <div class="invalid-feedback">
                    Campo numérico de 2 caracteres entero y 2 decimales
                  </div>
                </div>
              </div>
              <div class="col-6 col-sm-6 col-md-2 col-lg-2 col-xs-2">
                        <button type="button" id="btn-agregar" class="btn btn-primary hvr-shrink" style="width: 160px;" [disabled]="isValidFieldDatosLineaIntermediarioForm('valorTasa') ||
                          valorTasa.value.length == 0" (click)="agregarTasa()">
                  Agregar tasa
                </button>
              </div>
            </div>
            <div class="row">
              <div class="table-responsive">
                <div class="col-12 col-sm-6 col-md-6 col-lg-12 col-xs-6">
                  <table class="table table-striped table-borderless rounded">
                    <thead class="table_head">
                      <tr>
                        <th scope="col" class="no-styles table-header">
                          Tasas
                        </th>
                        <th scope="col" class="no-styles table-header">
                          Acciones
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (ta of tasasDePago; track ta; let i = $index) {
                        <tr>
                          <td scope="row">
                            {{ta}}
                          </td>
                          <td scope="row">
                            <button type="button" id="btn-borrar" (click)="eliminarTasa(i)">
                              <i class="fas fa-trash-alt"></i>
                            </button>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="row myForm mt-10 justify-content-md-center g-3">
              @if (!idLineaCredito) {
                <div class="col-12 col-md-2 container-btn">
                  <button type="submit" [disabled]="!datosLineaIntermediarioForm.valid" class="btn btn-primary hvr-shrink" style="width: 180px;">
                    @if (isLoading) {
                      <div class="spinner-grow text-light" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    }
                    {{ isLoading ? "" : "Registrar" }}
                  </button>
                </div>
              }
              @if (idLineaCredito) {
                <div class="col-12 col-md-2 container-btn">
                  <button type="submit" [disabled]="!datosLineaIntermediarioForm.valid" class="btn btn-primary hvr-shrink" style="width: 180px;">
                    Modificar
                  </button>
                </div>
              }
              <div class="col-12 col-md-2 container-btn">
                <button type="button" class="btn btn-primary hvr-shrink" style="width: 180px;" [routerLink]="['/intermediario/administracion/lineascredito']">
                  Volver
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      @if (isCreado) {
        <div class="alert alert-success alert-dismissible fade show" role="alert">
          La línea de crédito ha sido creada exitosamente
          <button type="button" class="close" data-bs-dismiss="alert" aria-label="Close">
          </button>
        </div>
      }
      <div class="footer-body"></div>
    </div>